import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateHsaSettings = {
  name: "updateHsaSettings" as const,
  input: z.object({
    teamId: zExt.objectId(),
    enabled: z.boolean(),
    reorderHsaPaymentMethodToTop: z.boolean(),
    sendGalePaymentInfoSubmittedEvents: z.boolean(),
    checkoutButtonsSkipShopPay: z.boolean(),
    /** Absent (stale client) keeps the stored value. */
    redoHandlesPaymentSessions: z.boolean().optional(),
    /** Absent (stale client) keeps the stored values. */
    intentSignals: z
      .object({
        lmnStarted: z.boolean(),
        lmnCompleted: z.boolean(),
        pdpWidget: z.boolean(),
        cartWidget: z.boolean(),
      })
      .optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
